import { initParameterLinks } from '../helpers/parameter-links';
import { initVideo } from '../components/video';
import { initModals } from '../components/modals';
import { initConsentManagement } from '../helpers/consent-management';
import { initTracking } from '../tracking';
import { initShowToggles } from '../helpers/hide-show';
import { initCaptchas } from '../helpers/captchas';
import { initFreeTrials } from '../forms/free-trial';
import { initAdvancedSelects } from '../forms/advanced-select';
import { initLogin } from '../forms/login';
import { initPreload } from '../helpers/preload';
import { shiftSubdomain } from '../helpers/extract-domain';
import { initPrefill } from '../forms/prefill';
import { initCustomerReferral } from '../forms/customer-referral';
import { initAnchorLinkOffset } from '../helpers/anchor-link-offset';
import { initChat } from '../helpers/chat';
import { ConsentFormHandlerFactory } from '../forms/consent-form-handler/ConsentFormHandlerFactory';
import { EbueroConsentFormHandler } from '../forms/consent-form-handler/EbueroConsentFormHandler';
import { generalCallbacks } from '../form-callbacks/general';
import { consentCallbacks } from '../form-callbacks/consent';
import { freeTrialCallbacks } from '../form-callbacks/free-trial';
import { loginCallbacks } from '../form-callbacks/login';
import { customerReferralCallbacks } from '../form-callbacks/customer-referral';
require('./custom');
const initializers = [
    initModals,
    initVideo,
    initConsentManagement,
    initTracking,
    initShowToggles,
    initAdvancedSelects,
    initFreeTrials,
    initLogin,
    initPreload,
    initCaptchas,
    initPrefill,
    initCustomerReferral,
    initAnchorLinkOffset,
    initChat,
    initParameterLinks,
];
const initialize = () => {
    ConsentFormHandlerFactory.getInstance().registerHandler(new EbueroConsentFormHandler());
    initializers.forEach((initializer) => {
        try {
            initializer();
        }
        catch (e) {
            console.log(e);
        }
    });
    if (document.querySelector('.form.quickorder')) {
        import('../forms/quickorder').then((module) => module.initQuickorder());
        import('../form-callbacks/quickorder').then((module) => Object.assign(window, module.quickorderCallbacks));
    }
};
initialize();
Object.assign(window, generalCallbacks, consentCallbacks, freeTrialCallbacks, loginCallbacks, customerReferralCallbacks);
window.shiftSubdomain = shiftSubdomain;
window.addLibsLoadedScript = (fn) => fn();
if (typeof window.libsLoadedScripts === 'object') {
    window.libsLoadedScripts.forEach((fn) => {
        try {
            fn();
        }
        catch (e) {
            console.error(e);
        }
    });
}
